<style lang="less" scoped>
.menu-container {
  padding-bottom: 32px;

  .first-menu-title {
    display: inline-block;
    margin-left: 24px;
    font-weight: 600;
    font-size: 16px;
    color: #000;
  }

  .second-menu-title {
    display: inline-block;
    margin-left: 36px;
    width: 214px;
    font-weight: 600;
    // color: #585B61;
    height: 20px;
    line-height: 20px;
  }

  .el-menu-div {

    .menu-right-icon {
      font-size: 12px;
      color: #000;
    }

    .third-menu-title {
      margin-left: 16px;
      ;
    }
  }
}
</style>

<template>
  <div class="menu-container" :style="menuCollapse ? 'width:121px' : 'width:294px'">
    <!-- background-color="#162E42" text-color="#8B8CA0" active-text-color="#fff" -->
    <el-menu :default-active="defaultActiveMenu" :collapse="menuCollapse" :default-openeds="defaultOpenKeys"
      class="el-menu-div" unique-opened @select="handleMenuSelect" text-color="#585B61" active-text-color="#4182EB">
      <!-- <div>{{menuList}}</div> -->
      <!-- 一级菜单 -->
      <template v-for="firstMenu in menuList">
        <el-menu-item
          v-if="firstMenu.meta && firstMenu.meta.type == 'noChild' && $S.checkUserMenu(firstMenu.children[0].name)"
          :key="'noChild-' + firstMenu.name" :index="firstMenu.children[0].name">
          <!-- <img :src="firstMenu.meta.icon" > -->
          <span slot="title" class="first-menu-title">{{ firstMenu.children[0].meta.title }}</span>
        </el-menu-item>

                <!-- 叶子节点（无子菜单，如安心包列表）直接渲染为可点击菜单项 -->
                <el-menu-item
                  v-else-if="(!firstMenu.children || firstMenu.children.length === 0) && firstMenu.name && $S.checkUserMenu(firstMenu.name)"
                  :key="'leaf-' + firstMenu.name" :index="firstMenu.name">
                  <span slot="title" class="first-menu-title">{{ (firstMenu.meta && firstMenu.meta.title) || firstMenu.name || '-' }}</span>
                </el-menu-item>

        <el-submenu
          v-else-if="firstMenu.meta && firstMenu.meta.type !== 'noChild' && firstMenu.children && firstMenu.children.length > 0 && $S.checkUserMenu(firstMenu.name)"
          :key="'sub-' + firstMenu.name" :index="firstMenu.name">
          <template slot="title">
            <!-- <img :src="firstMenu.meta.icon" > -->
            <span class="first-menu-title">{{ firstMenu.meta.title }}</span>
          </template>

          <!-- 二级菜单 -->
          <template v-for="secondMenu in firstMenu.children">
            <el-submenu
              v-if="secondMenu.meta && secondMenu.meta.type == 'hasChild' && $S.checkUserMenu(secondMenu.name)"
              :key="secondMenu.name" :index="secondMenu.name">
              <template slot="title">
                <!-- <div v-if="defaultOpenKeys[1] == secondMenu.name">{{secondMenu}}</div> -->
                <!-- <img :src="secondMenu.meta.activeIcon" v-if="defaultOpenKeys[1] == secondMenu.name"> -->
                <img :src="secondMenu.meta.icon">
                <!-- <i class="el-icon-arrow-right menu-right-icon"></i> -->
                <span class="second-menu-title">{{ secondMenu.meta.title }}</span>
                <i class="el-icon-arrow-right menu-right-icon"></i>
              </template>
              <template v-for="thirdMenu in secondMenu.children">
                <!-- 三级菜单 -->
                <el-menu-item v-if="$S.checkUserMenu(thirdMenu.name)" :key="thirdMenu.name" :index="thirdMenu.name"
                  class="second-menu-item">
                  <!-- <i class="el-icon-arrow-right menu-right-icon"></i> -->
                  <span class="second-menu-title">{{ thirdMenu.meta.title }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item
              v-if="secondMenu.meta && secondMenu.meta.type !== 'hasChild' && $S.checkUserMenu(secondMenu.name)"
              :key="secondMenu.name" :index="secondMenu.name">
              <!-- <i class="el-icon-arrow-right menu-right-icon"></i> -->
              <img :src="secondMenu.meta.activeIcon" v-if="defaultActiveMenu == secondMenu.name">
              <img :src="secondMenu.meta.icon" v-else>
              <span class="second-menu-title">{{ secondMenu.meta.title }}</span>
            </el-menu-item>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    init() { },
    handleMenuSelect(key, keyPath) {
      if (!key) return;
      this.$router.push({ name: key }).catch((err) => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('菜单跳转失败:', err);
        }
      });
    },
    // 把一级菜单数组拍平为左侧菜单可渲染的列表
    // marketingActivity 这类容器节点展开为它的 children，其它一级菜单原样保留
    flattenMenu(arr) {
      const flattened = [];
      arr.forEach((firstMenu) => {
        if (firstMenu && firstMenu.name === 'marketingActivity' && Array.isArray(firstMenu.children)) {
          firstMenu.children.forEach((child) => flattened.push(child));
        } else {
          flattened.push(firstMenu);
        }
      });
      return flattened
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    // 当前选中的菜单
    defaultActiveMenu() {
      return this.$store.state.curMenuRouter || [];
    },
    // 当前展开的菜单
    defaultOpenKeys() {
      return this.$store.state.curMenuOpened || [];
    },
    menuList() {
      // 优先根据当前路由的 meta.parent[0] 选择对应一级菜单的整棵子树
      // 处理 window.open 直接打开详情页的场景：此时 store.curMenuList 可能仍是来源页
      // （如用户信息管理）的菜单树，而路由已切到目标一级菜单（如充电设备管理）
      // 不能通过 commit 切换 curMenuList：vuex-persistedstate@2.x 默认监听 storage 事件，
      // 新窗口的 commit 会广播回原窗口，导致原窗口菜单错乱
      const routeTopName = this.$route.meta && this.$route.meta.parent && this.$route.meta.parent[0]
      if (routeTopName) {
        const all = this.$store.state.menuList
        if (Array.isArray(all)) {
          const found = all.find(m => m && m.name === routeTopName)
          if (found) {
            return this.flattenMenu([found])
          }
        }
      }
      // 回退到原逻辑：curMenuList（正常从 mainMenu 进入时已设置）→ 全量 menuList
      let arr = this.$store.state.curMenuList.length > 0 ? this.$store.state.curMenuList : this.$store.state.menuList;
      if (!Array.isArray(arr)) {
        return [];
      }
      return this.flattenMenu(arr)
    },
    menuCollapse() {
      // console.log(this.$store.state.menuCollapse)
      return this.$store.state.menuCollapse || false;
    },
  }
}
</script>